export const cdpProduct = {
  name: 'CDP',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Connect and activate customer data across your ecosystem to drive relevance with an intelligent customer data platform.',

  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: '$.annotations.URL',
          resource: 'tenant',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/fed1a6b9ca264da892313e5e996ac107',
  },
  color: 'red',
};
